import { useState, useEffect, useCallback } from 'react';
import CookieConsent, { Cookies } from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';

import styles from './CookieConsentBanner.module.scss';

export const COOKIE_NAME = 'blago_cookie_consent';
export const SHOW_COOKIE_BANNER_EVENT = 'show-cookie-banner';

export const showCookieBanner = () => {
  window.dispatchEvent(new Event(SHOW_COOKIE_BANNER_EVENT));
};

const CookieConsentBanner = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);

  const handleShow = useCallback(() => {
    Cookies.remove(COOKIE_NAME);
    setVisible(true);
  }, []);

  useEffect(() => {
    window.addEventListener(SHOW_COOKIE_BANNER_EVENT, handleShow);
    return () => window.removeEventListener(SHOW_COOKIE_BANNER_EVENT, handleShow);
  }, [handleShow]);

  if (!visible) return null;

  return (
    <CookieConsent
      location="bottom"
      buttonText={t('cookieConsent.accept')}
      declineButtonText={t('cookieConsent.decline')}
      enableDeclineButton
      cookieName={COOKIE_NAME}
      disableStyles
      containerClasses={styles.banner}
      contentClasses={styles.content}
      buttonWrapperClasses={styles.buttons}
      buttonClasses={styles.acceptButton}
      declineButtonClasses={styles.outlineButton}
      onAccept={() => setVisible(false)}
      onDecline={() => setVisible(false)}
      ButtonComponent={({ children, onClick, className, ...props }: any) => (
        <button className={className} onClick={onClick} {...props}>
          {children}
        </button>
      )}
    >
      {t('cookieConsent.message')}
    </CookieConsent>
  );
};

export default CookieConsentBanner;